<template>
  <v-toolbar class="transparent elevation-0">
    <v-row>
      <v-col class="px-0" cols="12">
        <v-row class="pl-3" align="center">
          <span
            style="
              font-family: Roboto;
              font-style: normal;
              font-weight: normal;
              font-size: 1rem;
            "
            >Pesquise uma cidade</span
          >
        </v-row>
        <v-autocomplete
          aria-label="Pesquisa por nomes de cidades"
          class="mt-4"
          v-model="model"
          :items="result"
          :loading="isLoading"
          :search-input.sync="search"
          no-filter
          hide-selected
          hide-details
          item-text="text"
          prepend-inner-icon="search"
          return-object
          clearable
          clear-icon="mdi-backspace-outline"
          outlined
          item-color="secondary lighten-1"
          color="secondary lighten-1"
        >
          <template v-slot:no-data>
            <v-list-item v-show="!afterSearch">
              <v-list-item-title>
                <span class="error--text">Não encontrado.</span>
              </v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-title>
                <strong>Sugestões para você</strong>
              </v-list-item-title>
            </v-list-item>
            <v-list
              class="transparent"
              v-for="(item, index) in pinnedSuggestions"
              :key="index"
            >
              <v-list-item @click="selectSuggestion(item)">
                <v-list-item-icon>
                  <v-icon left>{{ item.icon }}</v-icon>
                  <span> {{ item.temp }}°C</span>
                </v-list-item-icon>
                <v-list-item-content class="ml-n4">
                  <v-list-item-title>
                    <span>{{ item.text }}</span>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>
  </v-toolbar>
</template>

<script>
import moment from "moment";
export default {
  name: "CitiesSearchForm",
  data: () => ({
    result: [],
    isLoading: false,
    search: "",
    model: null,
    arrayDatetime: [],
    currentCity: null,
    afterSearch: false,
    pinnedSuggestions: [
      {
        text: "Curitiba",
        id: 4106902,
        slug: "curitiba",
        temp: Number,
        icon: "",
      },
      {
        text: "Foz Do Iguaçu",
        id: 4108304,
        slug: "foz do iguacu",
        temp: Number,
        icon: "",
      },
      {
        text: "Maringá",
        id: 4115200,
        slug: "maringa",
        temp: Number,
        icon: "",
      },
    ],
  }),
  async mounted() {
    await this.initialize();
  },
  methods: {
    selectSuggestion(item) {
      this.model = null;
      this.result = [];
      this.result.push(item);
      this.model = item;
    },
    async initialize() {
      this.searchOption = "Cidades";
      await this.$store.dispatch("loadCities");

      await this.$store.dispatch("loadHourlyForecastWeather", {
        id: this.pinnedSuggestions.map((item) => item.id),
      });

      const arrayLocationId = [4106902, 4108304, 4115200];

      const currentTime = moment()
        .tz("America/Sao_Paulo")
        .format("YYYYMMDDTHH");

      const resData = await this.$store.getters.hourlyForecastWeather;
      for (let index in resData) {
        this.arrayDatetime.push(this.formateDateTime(resData[index].datetime));
        if(this.arrayDatetime[index] == currentTime){
          for(let indexLocation in arrayLocationId){
            if(resData[index].locationId == arrayLocationId[indexLocation]){
              this.pinnedSuggestions.find((item) => {
                if(item.id == arrayLocationId[indexLocation]){
                  item.icon = this.mapIcon(resData[index].value.summaryId, resData[index].datetime);
                  item.temp = (resData[index].value.temp).toFixed(0);
                }
              })
            }
          }
        }
      }



      this.model = this.cities.find((item) => item.id === 4106902);
      if (navigator.geolocation) {
        var me = this;
        navigator.geolocation.getCurrentPosition(function (position) {
          const lat = position.coords.latitude;
          const long = position.coords.longitude;
          const geoApiUrl = `/telemetry/v1/public/county/${lat}/${long}`;
          fetch(geoApiUrl)
            .then((res) => res.json())
            .then((data) => {
              if (data) {
                me.currentCity = data;
                let city = me.cities.find((item) => item.id === data.id);
                me.model = city
                  ? city
                  : me.cities.find((item) => item.id === 4106902);
              } else {
                me.model = me.cities.find((item) => item.id === 4106902);
              }
            });
        });
      } else {
        alert("Geolocation is not supported by this browser.");
      }
      this.result = this.cities;
    },
    slugify(str) {
      str = str.toLowerCase();
      var from = "àáãäâèéëêìíïîòóõöôùúüûç";
      var to = "aaaaaeeeeiiiiooooouuuuc";
      for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
      }
      return str;
    },
    checkEquality(val) {
      val = this.slugify(val);
      this.result = [];
      this.result = this.cities.filter((item) => {
        if (item.slug.includes(val)) {
          return item;
        }
      });
      if (this.result.length === 0) {
        this.afterSearch = false;
      } else {
        this.afterSearch = true;
      }
      this.isLoading = false;
    },

    formateDateTime(x) {
      let utc = moment(x).tz("America/Sao_Paulo").format("YYYYMMDDTHH");
      return utc;
    },

    mapIcon(id, datetime) {
      let icon,
        isDay = true;
      let holder = moment(datetime, "YYYY-MM-DDTHH:mm:ssZ")
        .tz("America/Sao_Paulo")
        .format("HH");
      if (holder <= "06" || holder >= "18") {
        isDay = false;
      }

      if (id == 4) {
        icon = "icon-infohidro-wi-cloud";
      } else if (id == 6) {
        icon = "icon-infohidro-wi-rain";
      } else if (id == 7) {
        icon = "icon-infohidro-wi-thunderstorm";
      } else if (id == 8) {
        icon = "icon-infohidro-wi-snowflake-cold";
      } else if (id == 9) {
        icon = "icon-infohidro-wi-snow";
      } else if (id == 11) {
        icon = "icon-infohidro-wi-fog";
      } else if (id == 999) {
        icon = " ";
      }
      if (isDay == true) {
        if (id == 1) {
          icon = "icon-infohidro-wi-day-sunny";
        } else if (id == 2) {
          icon = "icon-infohidro-wi-day-sunny-overcast";
        } else if (id == 3) {
          icon = "icon-infohidro-wi-day-cloudy";
        } else if (id == 5) {
          icon = "icon-infohidro-wi-day-rain";
        } else if (id == 10) {
          icon = "icon-infohidro-wi-day-thunderstorm";
        } else if (id == 999) {
          icon = " ";
        }
      } else if (isDay == false) {
        if (id == 1) {
          icon = "icon-infohidro-wi-night-clear";
        } else if (id == 2) {
          icon = "icon-infohidro-wi-night-alt-partly-cloudy";
        } else if (id == 3) {
          icon = "icon-infohidro-wi-night-alt-cloudy";
        } else if (id == 5) {
          icon = "icon-infohidro-wi-night-alt-rain";
        } else if (id == 10) {
          icon = "icon-infohidro-wi-night-thunderstorm";
        } else if (id == 999) {
          icon = " ";
        }
      }
      return icon;
    },
  },
  computed: {
    cities() {
      let cities = this.$store.getters.cities;
      let aux = [];
      for (let city in cities) {
        let slug = this.slugify(cities[city].citname);
        let holder = {
          text: cities[city].citname,
          id: cities[city].citid,
          slug: slug,
        };
        aux.push(holder);
      }
      return aux;
    },
  },
  watch: {
    searchOption() {
      this.model = null;
      this.result = [];
    },
    model(val) {
      if (val) {
        this.$emit("result", val.id);
      }
    },
    search(val) {
      if (val) {
        if (val.length >= 2) {
          this.isLoading = true;
          setTimeout(() => {
            this.checkEquality(val);
          }, 2000);
        }
      }
    },
  },
};
</script>

<style scoped></style>
